import { Modal } from 'antd';

import type { FC } from 'react';
import '../styles/AppointmentMoveModal.scss';

interface AppointmentMoveModalProps {
  isOpen: boolean;
  originalStart: string;
  originalEnd: string;
  newStart: string;
  newEnd: string;
  fromEmployeeName?: string;
  toEmployeeName?: string;
  entityLabel?: string;
  onConfirm(): void;
  onCancel(): void;
}

export const AppointmentMoveModal: FC<AppointmentMoveModalProps> = ({
  isOpen,
  originalStart,
  originalEnd,
  newStart,
  newEnd,
  fromEmployeeName,
  toEmployeeName,
  entityLabel = 'Исполнитель',
  onConfirm,
  onCancel,
}) => {
  const employeeChanged = Boolean(
    fromEmployeeName && toEmployeeName && fromEmployeeName !== toEmployeeName
  );

  return (
    <Modal
      open={isOpen}
      title="Перенос записи"
      okText="Перенести"
      cancelText="Отменить"
      onOk={onConfirm}
      onCancel={onCancel}
      data-testid="reschedule-modal"
    >
      <div className="AppointmentMoveModal__content">
        {employeeChanged && (
          <div className="AppointmentMoveModal__row">
            <span className="AppointmentMoveModal__label">{entityLabel}:</span>
            <span
              className="AppointmentMoveModal__value"
              data-testid="reschedule-modal-employee"
            >
              {fromEmployeeName} → {toEmployeeName}
            </span>
          </div>
        )}
        <div className="AppointmentMoveModal__row">
          <span className="AppointmentMoveModal__label">Было:</span>
          <span
            className="AppointmentMoveModal__value"
            data-testid="reschedule-modal-time-old"
          >
            {originalStart} – {originalEnd}
          </span>
        </div>
        <div className="AppointmentMoveModal__row">
          <span className="AppointmentMoveModal__label">Станет:</span>
          <span
            className="AppointmentMoveModal__value"
            data-testid="reschedule-modal-time-new"
          >
            {newStart} – {newEnd}
          </span>
        </div>
      </div>
    </Modal>
  );
};
